import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authApi } from './services/auth';
import { assetClassesApi } from './services/assetClasses';
import { climateRiskApi } from './services/climateRisks';
import { climateScenarioApi } from './services/climateScenarios';
import { counterPartiesApi } from './services/counterParty';
import { countriesApi } from './services/countries';
import { emissionsApi } from './services/emission';
import { sectorApi } from './services/sector';
import { usersApi } from './services/users';
import { organizationApi } from './services/organization';

import authReducer from './slices/authSlice';

const setUpStore = () => {
  const store = configureStore({
    reducer: {
      [authApi.reducerPath]: authApi.reducer,
      [usersApi.reducerPath]: usersApi.reducer,
      [sectorApi.reducerPath]: sectorApi.reducer,
      [emissionsApi.reducerPath]: emissionsApi.reducer,
      [countriesApi.reducerPath]: countriesApi.reducer,
      [counterPartiesApi.reducerPath]: counterPartiesApi.reducer,
      [climateScenarioApi.reducerPath]: climateScenarioApi.reducer,
      [climateRiskApi.reducerPath]: climateRiskApi.reducer,
      [assetClassesApi.reducerPath]: assetClassesApi.reducer,
      [organizationApi.reducerPath]: organizationApi.reducer,
      auth: authReducer,
    },
    middleware: (getDM) => [
      ...getDM(),
      authApi.middleware,
      usersApi.middleware,
      sectorApi.middleware,
      emissionsApi.middleware,
      countriesApi.middleware,
      counterPartiesApi.middleware,
      climateScenarioApi.middleware,
      climateRiskApi.middleware,
      assetClassesApi.middleware,
      organizationApi.middleware,
    ]
  })
  setupListeners(store.dispatch);
  return store
}

export const store = setUpStore();